import React, { useState ,useEffect } from 'react';
import ButtonContainer from "./buttonContainer";
import UploadCard from "../../../../component/uploadCard";
import { useSelector } from 'react-redux';
import axiosInstance from '../../../../configuration/request';
import { useSnackbar } from '../../../../component/SnackbarContext';

  const uploadConfigs = {
    "delivery user": [
      { heading: "Upload driving licence", documentType: "PDF, JPEG or JPG" ,name: "driving_license"},
      { heading: "Upload Insurance (if any)", documentType: "PDF, JPEG or JPG" , name: "insurance" },
    ],
    "business user": [
      { heading: "Upload Industry License", documentType: "PDF, JPEG or JPG" , name: "industry_license"},
        {
    heading: "Upload Shop Image",
    documentType: "PDF, JPEG or JPG",
    name: "shop_image",
  },
    ],
  };

const UploadDocument = ({ nextHandler ,previousHandler ,uploadedDocs ,mode }) => {
  const showSnackbar = useSnackbar();
  const { userType } = useSelector(state => state.counter);
  const [uploadedFiles, setUploadedFiles] = useState([])
  const documents = uploadConfigs[userType] || [];

  useEffect(() => {
    if (uploadedDocs.length > 0) {
      setUploadedFiles(uploadedDocs);
    }
  }, [uploadedDocs]);

 const onSubmit = () => {
  const uploadedNames = uploadedFiles.map(file => file.name);

  if (userType === "delivery user") {
    const requiredDocs = ["driving_license", "insurance"];
    const isAllPresent = requiredDocs.every(doc => uploadedNames.includes(doc));
    if (!isAllPresent) {
         showSnackbar("Please upload both Driving License and Insurance.", "error");
         return
    }
  }

  if (userType === "business user") {
     const requiredDocs = ["industry_license", "shop_image"];
    const isPresent = requiredDocs.every(doc => uploadedNames.includes(doc));
    if (!isPresent) {
       showSnackbar("Please upload Industry License and spo image.", "error");
       return
    }
  }

  nextHandler(uploadedFiles, "upload-doc");
};

  
  const handleFileSelect = async (file, file_name) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post("/customer/upload/file", formData);
      const fileUrl = response.data?.url || "";
      setUploadedFiles((prev) => {
        const others = prev.filter((doc) => doc.name !== file_name);
        return [...others, { name: file_name, fileUrl }];
      });
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  return (
    <div >
      <div className="shadow-card flex gap-8 justify-center items-center flex-wrap py-7 px-6 rounded-[16px]">
        {documents.map((doc, idx) => {
              const uploadedDoc = uploadedFiles.find((f) => f.name === doc.name);
              return (
                <UploadCard
                  key={idx}
                  doc_name={doc.name}
                  heading={doc.heading}
                  documentType={doc.documentType}
                  onFileSelect={handleFileSelect}
                  fileUploaded={!!uploadedDoc}
                  fileUrl={uploadedDoc?.fileUrl}
                />
              );
            })}
      </div>

      <ButtonContainer handleNext={onSubmit} handlePrevious={previousHandler} isSubmit={true} mode={mode}/>
    </div>
  );
};

export default UploadDocument;
